import DecimalSetting from "./decimal-setting";
import EInvoiceDetailSetting from "./e-invoice-detail-setting";

export default {
  name: 'EInvoiceConfiguration',
  components: {
    DecimalSetting,
    EInvoiceDetailSetting
  },
  data() {
    return {
      settingOptions: [
        {
          SettingId: '1',
          Keyword: 'Số thập phân',
        },
        {
          SettingId: '2',
          Keyword: 'Chi tiết hóa đơn',
        }
      ],
      eInvoiceDetailOptions: [
        {
          DetailId: '1',
          Keyword: 'Hóa đơn điện tử',
        },
        {
          DetailId: '2',
          Keyword: 'Vé'
        }
      ],
      lv1Active: null,
      lv2Active: null,

    }
  },
  computed: {
    //TODO: Check user role

    // ...mapState({
    //   currentSiteID: (state) => state.auth.user.SiteID,
    //   $ls_GroupUserRoles: (state) => state.app.resources.GroupUsers,
    // }),
    // ...mapGetters({
    //   $lsGet_userSiteGroupRoleInfo: 'app/userSiteGroupRoleInfo'
    // }),
    // currentUserSiteGroupRoleInfo() {
    //   return this.$lsGet_userSiteGroupRoleInfo(this.currentSiteID);
    // },
    // groupRolesAllowConfig() {
    //   if (this.currentUserSiteGroupRoleInfo) {
    //     return this.$ls_GroupUserRoles
    //       .filter(s => s.GroupRoleLevel > this.currentUserSiteGroupRoleInfo.GroupRoleLevel)
    //       .sort((a, b) => a.GroupRoleLevel - b.GroupRoleLevel);
    //   }
    //   return [];
    // },

    isDecimalSetting() {
      return !!this.settingOptions.find(setting => setting.SettingId === this.lv1Active);
    }
  },
  methods: {
    setLv1Active(settingId) {
      this.lv1Active = settingId;
    }
  },

}